module.exports = __webpack_public_path__ + "static/media/fire.02f3aee7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/fire.svg
// module id = 63
// module chunks = 0